var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseModule } from './../commons/BaseModule';
import { getModule as originalGetModule, } from 'vuex-module-decorators';
import Vue from 'vue';
import Vuex, { Store } from 'vuex';
import { getAppInstance } from '../app';
var StoreModule = (function (_super) {
    __extends(StoreModule, _super);
    function StoreModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StoreModule.prototype.preInstall = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            Vue.use(Vuex);
            _this.store = new Store({});
            options.appModule.appOptions.store = _this.store;
            resolve(true);
        });
    };
    StoreModule.prototype.finalizeInstall = function (options) {
        return new Promise(function (resolve, reject) {
            resolve(true);
        });
    };
    return StoreModule;
}(BaseModule));
export default StoreModule;
export function getStoreInstance() {
    return getAppInstance().getModuleByType(StoreModule);
}
export function getModule(moduleClass) {
    var _a;
    return originalGetModule(moduleClass, (_a = getAppInstance().getModuleByType(StoreModule)) === null || _a === void 0 ? void 0 : _a.store);
}
export function mapGetters(moduleClass, getters) {
    var store = getModule(moduleClass);
    var res = {};
    getters.forEach(function (key) {
        res[key] = function mappedGetter() {
            if (!store)
                return;
            return store.context.getters[key];
        };
        res[key].vuex = true;
    });
    return res;
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/store/index.ts
// module id = HpaL
// module chunks = 10